import baseCalls from "../.internal/baseCalls.js";
import mapC from "./mapC.js";
import objectC from "./objectC.js";

export default baseCalls(mapC, objectC);